import React from 'react';

import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import RHFPasswordField from 'src/components/hook-form/rhf-password';
import LoadingButton from '@mui/lab/LoadingButton';
import { UseFormHandleSubmit, UseFormReturn } from 'react-hook-form';
import { CreateAndUpdateAdmType, UserPermissions } from 'src/types/users';
import AdmPermissions from '../adm-permissions/adm-permissions';
import { useMyDataStore } from 'src/store/me/me.store';

export interface AdmFormProps {
  methods: UseFormReturn;
  isEdit: boolean;
  isSubmitting: boolean;
  userPermissions: UserPermissions;
  onChangePermissions: (c: boolean, v: string, a: string) => void;
  onSubmit: (data: CreateAndUpdateAdmType) => Promise<void>;
  handleSubmit: UseFormHandleSubmit<CreateAndUpdateAdmType>;
}

export default function AdmForm({
  methods,
  isEdit,
  isSubmitting,
  userPermissions,
  onChangePermissions,
  onSubmit,
  handleSubmit,
}: AdmFormProps) {
  // const { } = useAdmForm();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.usersAdm)

  return (
    // @ts-ignore
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack spacing={4}>
            <Card>
              <CardContent>
                <Typography variant='h4'>Dados</Typography>
                <Box height={24} />
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                  }}
                >
                  <RHFTextField name="name" label="Nome" />

                  <RHFTextField name="email" label="E-mail" disabled={isEdit} />

                  <RHFPasswordField name="password" label="Senha" />
                </Box>
              </CardContent>
            </Card>
            <Card sx={{ p: 2 }}>
              <Box>
                <AdmPermissions
                  userPermissions={userPermissions}
                  onChangePermissions={onChangePermissions}
                />
              </Box>
            </Card>
          </Stack>
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton type="submit" variant="contained" loading={isSubmitting} disabled={(isEdit && !permissions?.update) || (!isEdit && !permissions?.create)}>
              {!isEdit ? 'Cadastrar' : 'Salvar'}
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
